import {
  Theme,
  ComponentsProps,
  ComponentsOverrides,
  ComponentsVariants,
} from '@mui/material/styles';

const muiTab: {
  defaultProps?: ComponentsProps['MuiTab'];
  styleOverrides?: ComponentsOverrides<Theme>['MuiTab'];
  variants?: ComponentsVariants['MuiTab'];
} = {
  styleOverrides: {
    root: ({ theme }) => ({
      '@media (min-width: 600px)': {
        minWidth: '160px',
      },
      '&.Mui-disabled': {
        opacity: 0.5,
        color: theme.palette.text.disabled,
        cursor: 'not-allowed',
      },
    }),
  },
};

export default muiTab;
